import { defineStore } from 'pinia'
import { DocumentType } from '@/models/DocumentType'

export const documentStore = defineStore('documentStore', {
    state: () => ({
        documentId: 0,
        documentType: DocumentType.Docx,
        documentUpdate: 0,
        loading: false,
    }),

    getters: {
        isIdmlDocument: (state) => state.documentType === DocumentType.Idml,
    },

    actions: {
        setDocumntId(documentId: number) {
            this.documentId = documentId;
        },

        setDocumentType(documentType: DocumentType) {
            this.documentType = documentType;
        },

        reloadDocument() {
            this.documentUpdate++;
        },

        startLoading() {
            this.loading = true;
        },

        stopLoading() {
            this.loading = false;
        },
    }
})